import { render, staticRenderFns } from "./repeat-duty-list-modal.vue?vue&type=template&id=12b5d250&scoped=true"
import script from "./repeat-duty-list-modal.vue?vue&type=script&lang=js"
export * from "./repeat-duty-list-modal.vue?vue&type=script&lang=js"
import style0 from "./repeat-duty-list-modal.vue?vue&type=style&index=0&id=12b5d250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5d250",
  null
  
)

export default component.exports